import React from 'react'
import PropTypes from 'prop-types'

import Text from 'components/common/Text'

/** Info about a person: his name, age and distance (if available). */
const PersonInfo = ({ firstName, age, distance, hideDistance, big }) => {
  return (
    <div>
      <Text color={big ? 'white' : 'black'} bold={big} size={big ? 24 : 18}>
        {firstName}, {age}
      </Text>
      {!hideDistance &&
        distance && (
        <Text color={big ? 'white' : 'grey'} size={big ? 18 : 16}>
          {distance}
        </Text>
      )}
    </div>
  )
}

PersonInfo.propTypes = {
  /** Name of the person */
  firstName: PropTypes.string.isRequired,
  /** Age of the person */
  age: PropTypes.number.isRequired,
  /** Distance to the person */
  distance: PropTypes.string,
  /** Show a big version */
  big: PropTypes.bool,
  /** Completely hide distance section */
  hideDistance: PropTypes.bool
}

PersonInfo.defaultProps = {
  big: false,
  hideDistance: false
}

export default PersonInfo



// WEBPACK FOOTER //
// ./src/components/profile/PersonInfo.js